import { useMutation } from '@tanstack/react-query';
import apiClient from '../api/client';
import { Button } from './ui/button';
import { FaceVerifyScreens } from '../constants/face.const';

interface VerifyFaceResponse {
  success: boolean;
  status: number;
  data: {
    VerificationUrl: string;
    BizToken: string;
    VerificationURL: string;
    RequestId: string;
  };
}

interface ChangePhoneNumberProps {
  screen: FaceVerifyScreens;
}

const ChangePhoneNumber: React.FC<ChangePhoneNumberProps> = ({ screen }) => {
  const getVerifyFaceToken = useMutation<VerifyFaceResponse, Error>({
    mutationFn: () =>
      apiClient
        .post<VerifyFaceResponse>('/face/register', { screen })
        .then((res) => res.data),
    onSuccess: (response) => {
      const url = response.data.VerificationUrl;
      window.location.href = url;
    },
    onError: (error) => {
      console.error('Face verify error', error);
      // show user-friendly notification here
    }
  });

  return (
    <>
      <Button
        variant="link"
        className="decoration-[#5B5959]"
        onClick={() => getVerifyFaceToken.mutate()}
        disabled={getVerifyFaceToken.isPending}
      >
        <p className="text-[#5B5959]">Can't access old phone number?</p>
      </Button>

      {/* <Button
        variant="link"
        className="decoration-[#5B5959]"
        onClick={() => verifyFace.mutate()}
        disabled={verifyFace.isPending}
      >
        <p className="text-[#5B5959]">testing</p>
      </Button> */}
    </>
  );
};

export default ChangePhoneNumber;
